import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';

export const COMPONENTS = [ConfirmationModalComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [TranslateModule],
  exports: COMPONENTS,
})
export class SharedComponentsModule {}
